/*
 * The /x list gate: which (module, listing) pairs the client may send to /x/list.
 *
 * Both flags come from the workspace bootstrap. `x` is the server's verdict that the ported
 * endpoint can serve this listing at all; `preference` says the user has saved column
 * overrides for it, which the port does not honour -- serving one would render the DEFAULT
 * columns, silently undoing the preference (SS06055). The map is DERIVED from those flags,
 * so anything that changes them mid-session has to come back through here; a stale entry
 * sends the next request to a lane the server has already refused.
 */
import Vue from "vue";

export function isXListMenu(menu) {
  return Boolean(menu && menu.id && menu.x === true && menu.preference !== true);
}

export function buildXListMenuMap(workspace) {
  const map = {};

  if (!workspace || !Array.isArray(workspace.vectors)) {
    return map;
  }

  workspace.vectors.forEach(module => {
    updateXListModuleMap(map, module);
  });

  return map;
}

export function updateXListModuleMap(map, module) {
  if (!map || !module || !module.id) return;

  Vue.delete(map, module.id);

  if (!Array.isArray(module.menus)) return;

  module.menus.forEach(menu => {
    updateXListListingMap(map, module.id, menu);
  });
}

export function updateXListListingMap(map, moduleId, listing) {
  if (!map || !moduleId || !listing || !listing.id) return;

  if (isXListMenu(listing)) {
    if (!map[moduleId]) {
      Vue.set(map, moduleId, {});
    }

    Vue.set(map[moduleId], listing.id, true);
  } else if (map[moduleId]) {
    Vue.delete(map[moduleId], listing.id);

    if (!Object.keys(map[moduleId]).length) {
      Vue.delete(map, moduleId);
    }
  }
}
